import { render } from "./ContractList.vue?vue&type=template&id=d4ea3ba2"
import script from "./ContractList.vue?vue&type=script&lang=ts"
export * from "./ContractList.vue?vue&type=script&lang=ts"
script.render = render

export default script